import cx from "classnames";

import styles from "./ErrorPage.module.scss";
import Image from "components/Image";
import Wordmark from "assets/atlantic-logo.svg";
import bigA from "assets/images/big-a.png";
import tape1 from "assets/images/500-page-tape-1.png";
import tape2 from "assets/images/500-page-tape-2.png";
import constructionWorkers from "assets/images/500-page-construction-workers.png";

const ErrorPage = () => {
  return (
    <div className={styles.root}>
      <Image
        className={cx(styles.tape, styles.tape1)}
        src={tape1}
        alt=""
        lazy={false}
      />
      <Image
        className={cx(styles.tape, styles.tape2)}
        src={tape2}
        alt=""
        lazy={false}
      />
      <main className={styles.main}>
        <div className={styles.logos}>
          <Image className={styles.bigA} src={bigA} alt="" lazy={false} />
          <Wordmark className={styles.wordmark} />
        </div>
        <div className={styles.message}>
          <div className={styles.text}>
            <h1 className={styles.headline}>We&apos;re working on it!</h1>
            <p className={styles.sorry}>
              We&apos;re having trouble displaying the page you&apos;re looking
              for.
              <br />
              We apologize, and expect to resolve the problem soon.
            </p>
            <p className={styles.cta}>
              If you need immediate assistance,{" "}
              <a
                className={styles.contact}
                href="https://support.theatlantic.com/hc/en-us/requests/new"
              >
                contact our Customer Care team.
              </a>
            </p>
          </div>
          <Image
            className={styles.constructionWorkers}
            src={constructionWorkers}
            alt=""
            lazy={false}
          />
        </div>
      </main>
    </div>
  );
};

export default ErrorPage;
